import React from 'react';
import { Star } from 'lucide-react';
const testimonials = [{
  initials: 'MR',
  name: 'Martín R., Buenos Aires',
  role: 'Entrenador de Rugby en Club de Barrio',
  text: '"Organicé todo el mes de entrenamientos en una tarde. Nunca más llego al campo sin saber qué ejercicio voy a dar."'
}, {
  initials: 'CG',
  name: 'Carlos G., Córdoba',
  role: 'Entrenador Infantil en Club Municipal',
  text: '"Mis M13 mejoraron el pase y el apoyo desde la primera semana con el Tomo 3. Los padres empezaron a notar la diferencia."'
}, {
  initials: 'LF',
  name: 'Lucas F., Rosario',
  role: 'Entrenador Juvenil Independiente',
  text: '"Antes tardaba una hora armando cada entrenamiento. Ahora son 5 minutos y llego con todo claro al campo."'
}];
export function SocialProof() {
  return <section className="bg-[#F5F5F5] py-16 px-4" data-id="element-275">
      <div className="max-w-6xl mx-auto" data-id="element-276">
        <div className="grid grid-cols-1 md:grid-cols-3 gap-8" data-id="element-277">
          {testimonials.map((t, i) => <div key={i} className="bg-white p-8 rounded-2xl shadow-sm border border-gray-100 flex flex-col h-full" data-id="element-278">
              <div className="flex items-center gap-4 mb-4" data-id="element-279">
                <div className="w-12 h-12 bg-[#1B4D2E] text-white rounded-full flex items-center justify-center font-bold text-lg" data-id="element-280">
                  {t.initials}
                </div>
                <div className="flex gap-1" data-id="element-281">
                  {[...Array(5)].map((_, idx) => <Star key={idx} className="fill-[#FFD700] text-[#FFD700]" size={16} data-id="element-282" />)}
                </div>
              </div>
              <p className="text-gray-700 italic mb-6 flex-grow text-lg" data-id="element-283">
                {t.text}
              </p>
              <div data-id="element-284">
                <p className="font-bold text-gray-900" data-id="element-285">— {t.name}</p>
                <p className="text-sm text-gray-500" data-id="element-286">{t.role}</p>
              </div>
            </div>)}
        </div>
      </div>
    </section>;
}